import { Component, OnInit, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { Record } from 'src/app/models/record';
import { UserService } from 'src/app/services/user.service';
import { ApiService } from 'src/app/services/api.service';
import { PurchaseSuggestion } from 'src/app/models/purchase-suggestion';
import { LocaleService } from 'src/app/services/locale.service';
import { Util } from 'src/app/util';
import { ToastService } from '../../_core/services/toast.service';

@Component({
  selector: 'app-purchase-suggestions-item',
  templateUrl: './purchase-suggestions-item.component.html',
  styleUrls: ['./purchase-suggestions-item.component.scss'],
})
export class PurchaseSuggestionsItemComponent implements OnInit, OnChanges {
  private readonly toastService = inject(ToastService);

  @Input()
  record: Record;

  @Input()
  requestedBy: number;

  @Input()
  alreadyInLibrary: boolean;

  @Input()
  solutionType: string;

  @Input()
  deleted: string;

  suggestion: PurchaseSuggestion;
  suggestButtonText = 'results.suggestions.suggest';
  SOLUTION_UNLIMITED = Util.SOLUTION_UNLIMITED;

  constructor(
    private userService: UserService,
    private localeService: LocaleService,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    this.suggestion = this.userService.purchaseSuggestions.find((s) => s.nInf === this.record.id);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.deleted && !changes.deleted.isFirstChange()) {
      const recordId = changes.deleted.currentValue;

      if (recordId === this.record.id) {
        delete this.suggestion;
      }
    }

    if (changes.alreadyInLibrary && changes.alreadyInLibrary.currentValue) {
      this.suggestButtonText = 'results.suggestions.moreCopies';
    }
  }

  suggestTitle() {
    this.apiService
      .createUserPurchaseSuggestions({
        nInf: this.record.id,
        title: this.record.title,
        author: this.record.author,
        userId: this.userService.getUserId(),
      })
      .subscribe((result) => {
        this.suggestion = result;
        this.suggestion.coverUrl = this.record.coverImageUrl;
        this.suggestion.icon = this.record.icon;
        this.userService.purchaseSuggestions.push(this.suggestion);
        this.userService.purchaseSuggestions.sort((a, b) => b.creationDate.valueOf() - a.creationDate.valueOf());
        this.toastService.showToast('messages.suggestions.added');
      });
  }

  cancelSuggestion() {
    this.apiService.cancelUserPurchaseSuggestions(this.suggestion).subscribe((result) => {
      this.userService.removeSuggestion(result);
      this.toastService.showToast('messages.suggestions.removed');
      delete this.suggestion;
    });
  }
}
